<div [formGroup]="formGroup">
  <mat-form-field class="form-field" subscriptSizing="dynamic">
    <mat-label [attr.for]="input.key">{{ input.label | translate }}</mat-label>
    @switch (input.controlType) {
      @case ('textbox') {
        <input [formControlName]="input.key" [id]="input.key" [type]="input.type" [attr.aria-label]="input.key" matInput />
      }
      @case ('dropdown') {
        <mat-select [id]="input.key" [formControlName]="input.key">
          @for (opt of input.options; track opt.key) {
            <mat-option [value]="opt.key">
              {{ opt.value | translate }}
            </mat-option>
          }
        </mat-select>
      }
    }
  </mat-form-field>
  @if (!isValid) {
    <mat-error class="errorMessage" [translate]="'UI.Error.Required'"></mat-error>
  }
</div>
